module.exports = __webpack_public_path__ + "img/electronic-certificate.97977764.png";